import { TpvBusinessUnit } from '@app/domain/models/tpv/business-unit.model';
import { BusinessUnitDto } from '@app/data/dtos/tpv/business-unit.dto';

/** DTO de unidad de negocio -> entidad de dominio (id = id_unit). */
export function mapBusinessUnit(dto: BusinessUnitDto): TpvBusinessUnit {
  return {
    idUnit: dto.id_unit,
    idCompany: dto.id_company,
    orgIdCompany: dto.org_id_company,
    name: dto.name ?? dto.unit_name ?? dto.business_unit_name ?? '',
    companyName: dto.company_name,
    status: dto.status ?? '',
    entity: dto.entity,
    totalMerchants: dto.total_merchants,
  };
}
